export default __webpack_public_path__ + "static/media/weatherIcon.16fae246.png";